import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Container, Row, Col, media } from "styled-bootstrap-grid";
import ContactButton from "../Button/ContactButton";
import HamburgerButton from "../Button/HamburgerButton";

export enum Variant {
  dark,
  light,
}

type HeaderProps = {
  variant?: Variant;
  className?: string;
};

const PageHeader = styled.header<HeaderProps>`
  top: 30px;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  padding: 20px 10px;
  z-index: 99;
  font-family: "DIN2014";

  .gatsby-image-wrapper {
    max-width: 160px;
    max-height: 41px;
  }

  ${media.lg`
    padding: 20px 50px;

    .gatsby-image-wrapper {
      max-width: 252px;
      max-height: 65px;
    }
  `}
`;

const StyledCol = styled(Col)`
  text-align: right;
`;

const Navigation = styled.ul`
  list-style: none;
  text-align: right;
  display: inline-flex;
  flex-direction: row;
`;

const NavigationItem = styled.li`
  margin-right: 30px;
  text-align: center;

  &:last-child {
    margin-right: 0;
  }
`;

const navigationList = [
  {
    label: "Find a solution",
    to: "/find-a-solution/",
  },
  {
    label: "Products",
    to: "/products/",
  },
  {
    label: "Academy",
    to: "/academy/",
  },
  {
    label: "About us",
    to: "/about-us/",
  },
  {
    label: "Careers",
    to: "/careers/",
  },
];

const NavLink = styled(Link)<HeaderProps>`
  color: ${(props) => (props.variant === Variant.dark ? "#000005" : "#FFFFFF")};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  text-decoration: none;

  &:hover {
    color: #fbba18;
  }
`;

NavLink.defaultProps = {
  activeStyle: {
    color: "#fbba18",
    fontWeight: "800",
  },
};

const Header: React.FC<HeaderProps> = ({
  variant = Variant.dark,
  className = "",
}) => {
  return (
    <PageHeader className={className} variant={variant}>
      <Container fluid={+true}>
        <Row alignItems="center">
          <Col col={9} lg={3}>
            <Link to="/" aria-label="Home Page">
              {variant === Variant.dark && (
                <StaticImage
                  src="../../../images/SPITWATER_CMYK_Logo_Corporate_Positive.png"
                  alt="logo"
                  placeholder="blurred"
                  layout="fixed"
                />
              )}
              {variant === Variant.light && (
                <StaticImage
                  src="../../../images/SPITWATER_CMYK_Logo_Corporate_Negative.png"
                  alt="logo"
                  placeholder="blurred"
                  layout="fixed"
                />
              )}
            </Link>
          </Col>
          <StyledCol col={9} hiddenLgDown>
            <Navigation>
              {navigationList.map((item, index) => (
                <NavigationItem key={index}>
                  <NavLink to={item.to} className="" variant={variant}>
                    {item.label}
                  </NavLink>
                </NavigationItem>
              ))}
              <NavigationItem>
                <ContactButton to="/contact-us/" className="">
                  Contact
                </ContactButton>
              </NavigationItem>
            </Navigation>
          </StyledCol>
          <StyledCol col={3} hiddenLgUp>
            <HamburgerButton variant="light" />
          </StyledCol>
        </Row>
      </Container>
    </PageHeader>
  );
};

export default Header;
